import { observer } from 'mobx-react-lite';
import styles from '@features/cart/components/CartProductImage/CartProductImage.styles';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  image: string;
  availability: boolean;
  miniCart: boolean;
  productName?: string;
  title?: string;
};
const CartProductImage = ({
  image,
  availability,
  miniCart,
  productName,
  title
}: PropsType) => <div sx={styles.imageContainer(availability, miniCart)} data-cy="CartProductImage" title={title}>
    <ResponsiveImage image={image} width={100} height={100} alt={productName || 'Zdjęcie produktu'} objectFit="contain" />
  </div>;
export default observer(CartProductImage);